<script>
export default {
    data() {
        return {
            localSearch: '',
            searchDebounceTimer: null,
        };
    },
    mounted() {
        // Initialize local search from store
        this.localSearch = this.$store.getters.CORPORATE_REQUESTS_SEARCH;
    },
    methods: {
        handleSearchInput() {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.updateSearch(this.localSearch);
            }, 300);
        },
        updateSearch(value) {
            this.$store.commit('SET_SEARCH_QUERY', value);
            this.$store.dispatch('applyFilters');
        },
        clearSearch() {
            this.localSearch = '';
            this.updateSearch('');
        },
    },
};
</script>

<template>
    <div class="filters_container">
        <div class="search_box">
            <input
                v-model="localSearch"
                @input="handleSearchInput"
                type="text"
                placeholder="Search by company, contact, or email..."
                class="search_input"
            />
            <button
                v-if="localSearch"
                @click="clearSearch"
                class="clear_button"
            >
                ✕
            </button>
        </div>
    </div>
</template>

<style scoped>
.filters_container {
    margin-bottom: 20px;
}

.search_box {
    position: relative;
    max-width: 500px;
}

.search_input {
    width: 100%;
    padding: 10px 40px 10px 15px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    background: var(--background-color);
    color: var(--text-color);
    font-size: 14px;
    transition: border-color 0.2s ease;
}

.search_input:focus {
    outline: none;
    border-color: var(--primary-color);
}

.clear_button {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--text-color-secondary);
    cursor: pointer;
    font-size: 18px;
    padding: 5px;
}

.clear_button:hover {
    color: var(--text-color);
}
</style>
